import styled from 'styled-components';

import { ButtonToTop } from '@shared/components/button-to-top';

export const QuestPaginationContainer = styled.div`
	position: relative;
	display: flex;
	padding: 28px 0;
	min-height: 100px;
	align-items: center;
	justify-content: center;
`;

export const ToTop = styled(ButtonToTop)`
	position: absolute;
	right: 0;
`;
